import React, { useState } from "react";
import "./Accordion.scss";

const Accordion = ({ children, size = "md", className = "" }) => {
  /* === useState === */
  const [openIndex, setOpenIndex] = useState(null); // Tracks the currently open accordion item
  /* === End useState === */

  /* === Handlers === */
  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle open/close
  };
  /* === End Handlers === */

  /* === Clone Children with Props === */
  const clonedChildren = React.Children.map(children, (child, index) =>
    React.cloneElement(child, {
      isOpen: openIndex === index,
      onToggle: () => toggleItem(index),
      size,
    })
  );
  /* === End Clone Children === */

  return (
    <div className={`accordion ${className} ${size}`}>{clonedChildren}</div>
  );
};

export default Accordion;
